import React, { Component } from "react";
import 'normalize.css';
import './css/App.css';
import LogIn from './components/LogIn.js';
import Game from './components/Game.js';
import LoadingScreen from './components/LoadingScreen.js';
import Cookies from 'js-cookie';

class App extends Component {
    constructor(props) {
        super(props);
        this.submitLogin = this.submitLogin.bind(this);
        this.discordLogin = this.discordLogin.bind(this);
        this.submitRegister = this.submitRegister.bind(this);
        this.logOut = this.logOut.bind(this);
        this.state = {
            loggedIn: false,
            userJustRegistered: false,
            loginError: ''
        }
    }

    componentDidMount() {
        let serverUrl = 'http://localhost:9000/'
        if (process.env.NODE_ENV === 'development') serverUrl = 'http://localhost:9000/'
        else if (process.env.NODE_ENV === 'production') serverUrl = window.location.protocol + '//' + window.location.host + '/';
        this.setState({ serverUrl: serverUrl }, this.isLogged);
        // this.setState({ serverUrl: serverUrl });
    }


    isLogged() {
        const options = {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
            },
            credentials: 'include'
        }
        fetch(this.state.serverUrl + 'auth/check', options)
            .then(
                res => res.json().then(json => {
                    if (json.message === 'success') {
                        this.setState({ loggedIn: true });
                    } else {
                    }
                })
            )
            .catch(err => (console.log(err)));
    }

    render() {
        if (this.state.loggedIn == true) {
            return (
                <div>
                    <Game logOut={this.logOut} loggedIn={this.state.loggedIn} serverUrl={this.state.serverUrl} />
                </div>
            );
        }
        else if (this.state.loggedIn == false) {
            return (
                <div className="App">
                    <LogIn loginError={this.state.loginError} discordLogin={this.discordLogin} submitLogin={this.submitLogin} submitRegister={this.submitRegister} userJustRegistered={this.state.userJustRegistered} serverUrl={this.state.serverUrl} />
                </div>
            )
        }
        else {
            console.log('ŵaiting', this.state.loggedIn)
            return (
                <div className="App">
                    <LoadingScreen />.
                </div>
            )
        }
    }

    discordLogin() {

    }

    submitLogin(values, provider) {
        this.setState({ loggedIn: 'checking' });
        const options = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            credentials: 'include',

            body: JSON.stringify(values)
        }

        fetch(this.state.serverUrl + "auth/login", options)
            .then(res => res.json().then(json => {

                console.log(json);
                if (json.message === 'success') {
                    this.setState({ loggedIn: true });
                } else if (json.error === 'User not found') {
                    this.setState({ loginError: 'user', loggedIn: false });
                    // User does^t exist
                } else if (json.error === 'Incorrect password') {
                    this.setState({ loginError: 'password', loggedIn: false });
                    // Wrong password
                }
                else {
                    this.setState({ loginError: 'unknown', loggedIn: false });
                    // Unknown error
                }

            }));
    }

    submitRegister(values) {
        this.setState({ loggedIn: 'checking' });
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(values)
        }

        fetch(this.state.serverUrl + "auth/signup", options)
            .then(res => res.json().then(json => {
                console.log(json);
                if (json.message === 'success') {
                    this.setState({ userJustRegistered: true, loggedIn: true })
                }
            }));
    }

    logOut() {
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
        }

        fetch(this.state.serverUrl + "auth/logout", options)
            .then(res => res.json().then(json => {
                console.log(json);
                if (json.message === 'success') {
                    this.setState({ loggedIn: false })
                }
            }));


    }
}

export default App;
